import React from "react";
import { Grid, Card, CardContent, Box, Avatar, Typography, Paper, Divider } from "@mui/material";

const KPISection = ({ title, data, color, icon }) => {
  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold", color: color, mb: 2 }}>
          {icon} {title}
        </Typography>
      </Box>
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {data.map((kpi, index) => (
          <Grid item xs={12} sm={6} md={4} lg={2} key={index}>
            <Card
              sx={{ height: "100%", position: "relative", overflow: "visible" }}
            >
              <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <Avatar sx={{ bgcolor: kpi.color, mr: 2 }}>{kpi.icon}</Avatar>
                  <Box>
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{ fontWeight: "bold" }}
                    >
                      {kpi.value}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {kpi.title}
                    </Typography>
                  </Box>
                </Box>
                
                {/* Footer Description */}
                <Box sx={{ mt: 0, pt: 0, borderTop: "1px solid #e0e0e0" }}>
                  <Typography variant="caption" sx={{ color: "#6c757d", fontStyle: "italic" }}>
                    {kpi.description}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default KPISection;

